import { checkIfRecaptchaEnabled } from '../ReCaptcha.helpers';
import { reCaptchaModel } from './reCaptcha.model';

/**
 * State machine for synchronizing callback-based ReCaptcha component events
 */
export const reCaptchaMachine = reCaptchaModel.createMachine({
  context: reCaptchaModel.initialContext,
  initial: checkIfRecaptchaEnabled() ? 'loading' : 'disabled',
  states: {
    loading: {
      on: {
        LOAD: 'ready',
      },
    },
    ready: {
      on: {
        EXECUTE: 'executing',
      },
    },
    executing: {
      on: {
        VERIFY: 'ready',
        ERROR: 'ready',
        RESET: 'ready',
      },
    },
    disabled: {},
  },
});
